import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '../../assets/icons/support-icon.svg'


const _hoisted_1 = { class: "message items-center support__title" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "support icon"
}, null, -1)
const _hoisted_3 = { class: "support__subTitle" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_page = _resolveComponent("q-page")!

  return (_openBlock(), _createBlock(_component_q_page, { class: "dashboard__page text-center" }, {
    default: _withCtx(() => [
      _createElementVNode("h5", _hoisted_1, _toDisplayString(_ctx.$t('pages.support.title')), 1),
      _hoisted_2,
      _createElementVNode("h6", _hoisted_3, _toDisplayString(_ctx.$t('pages.support.logo')), 1),
      _createVNode(_component_q_btn, {
        href: "https://t.me/masons_sup",
        target: "_blank",
        "no-caps": "",
        rounded: "",
        outline: "",
        color: "primary",
        class: "support__btn",
        label: _ctx.$t('pages.support.label')
      }, null, 8, ["label"])
    ]),
    _: 1
  }))
}